import FileDrop from './quote/FileDrop'
import { useDraftFiles } from '../lib/draftStore'
import { ESTIMATE_PATH, navigate } from '../lib/router'
import { track } from '../lib/analytics'

/**
 * A FOOLDALI FELTOLTO - A HEROBAN.
 *
 * ────────────────────────────────────────────────────────────────────
 * A FO MUVELET OTT ALL, AHOL A LATOGATO ELOSZOR NEZ.
 *
 * A 2.0 elott a feltolto a negyedik szakaszban allt, a hero pedig egy
 * „Kiszamolom az arat" gombot mutatott, ami a `/arbecsles` URES feltoltojere
 * vitt. Ket kattintas es egy oldalvaltas allt a latogato es az elso ar
 * kozott. Most a fajl kivalasztasa MAGA az elso lepes: amint a latogato
 * fajlt valaszt vagy ejt ra, atkerul a `/arbecsles` oldalra, es a beolvasas
 * ott AZONNAL megkezdodik - a fajlvalasztot NEM kell ujra megnyitnia.
 *
 * A FOOLDALON TOVABBRA SINCS TELJES URLAP. Anyag, szin, atvetel csak a
 * fajl utan jon, a sajat oldalan.
 *
 * A MERES VALTOZATLAN: a blokknev marad `drop`, tehat az `upload_cta_clicked`
 * es a `file_picker_opened` `place` erteke ugyanaz, mint a regi, lejjebb
 * allo feltoltonel. A tolcser-riport igy a 2.0 elotti es utani napokat
 * ugyanazzal a szuroval hasonlitja ossze.
 * ────────────────────────────────────────────────────────────────────
 */
export default function HomeUploader(): JSX.Element {
  const draft = useDraftFiles()

  const start = (files: File[]): void => {
    if (!files.length) return
    track('homepage_upload_started', {
      count: files.length,
      has_zip: files.some((f) => f.name.toLowerCase().endsWith('.zip'))
    })

    /*
      A `File` objektumok MEMORIABAN kelnek at. Sorosítani nem lehet oket,
      es nem is kell: a Provider a Root FOLOTT al, tehat az utvonalvaltas
      nem torli az allapotot.
    */
    draft.handOver(files)
    navigate(ESTIMATE_PATH)
  }

  return (
    <div className="home-upload">
      <FileDrop
        onFiles={start}
        title="Válaszd ki a kész 3D fájlt"
        hint="STL, OBJ, 3MF vagy ZIP"
        dragNote="…vagy húzd ide, akár egyszerre többet"
        action="Fájl kiválasztása"
      />

      <p className="home-upload__note">
        A fájl csak az ajánlatkérés elküldésekor kerül hozzánk. Addig a méretet,
        térfogatot és anyagigényt a saját böngésződ számolja ki.
      </p>
    </div>
  )
}
